<template>
    <div class="towerTab" style="background: lightgreen;">
        <p class="towerBottom" style="background-color: lightgreen"></p>
        <p style="margin-top:8px">
            七星列传<span style="color:red;font-weight:bold;margin-left:8px;font-size:12px">热度:582</span><small style="position:absolute; right:10px"><a href="score.php?name=qxlz&amp;num=10" target="_blank" style="color:gray">[<span style="color:red;font-weight:bold">62</span>条评论]</a></small>
            <span class="towerAuths"><span class="towerAuth">Black_leaves</span></span><span class="towerTag"><span style="color:red">测试期</span>&nbsp;境界塔&nbsp;平面塔&nbsp;连载塔&nbsp;210层</span>
        </p>
        <p class="towerInfo" onclick="play('qxlz');window.open('https://h5mota.com/games/qxlz/', '_blank')" style="bottom: 70px;"></p>
        <p class="towerAuthString">七星列传第二章已复刻完成，具体内容与原版略有区别，欢迎体验！</p>
    </div>
</template>

<script>
export default {

}
</script>

<style lang="less" scoped>
.towerTab {
    color: black;
    text-align: left;
}
.towerTab {
    background-color: rgba(252, 252, 252, 0.6);
    border-radius: 5px;
    box-sizing: border-box;
    box-shadow: 0 2px 2px 0 rgba(0,0,0,.14), 0 3px 1px -2px rgba(0,0,0,.2), 0 1px 5px 0 rgba(0,0,0,.12);
}
.towerTab {
    float: left;
    margin-bottom: 12px;
    margin-left: 1%;
    margin-right: 1%;
    // @media screen and (min-width: 1280px) {
    //     margin-left: 0.5%;
    //     margin-right: 0.5%;
    // }
    overflow: hidden;
    position: relative;
    height: 270px;
    width: 98%;
    @media screen and (min-width: 1280px) {
        width: 23%;
    }
    @media screen and (max-width: 1279px) and (min-width: 960px) {
        width: 31.333333%;
    }
    @media screen and (max-width: 959px) and (min-width: 600px) {
        width: 48%;
    }
    background-origin: border-box !important;
    & > * {
        margin: 3px 10px;
    }
    & > :last-child {
        margin-bottom: 8px;
    }
}
.towerBottom {
    position: absolute;
    margin: 0;
    bottom: 0;
    height: 8px;
    width: 100%;
}
.towerInfo {
    font-size: 12px;
    cursor: pointer;
    background-color: rgba(240, 240, 240, 0.6);
    position: absolute;
    top: 35px;
    left: 0;
    bottom: 26px;
    right: 0;
    overflow: auto;
    padding: 2px 5px;
}
.towerAuthString {
    font-size: 13px;
    position: absolute;
    left: 0;
    bottom: 26px;
    font-weight: bold;
}
.towerAuths {
    position: absolute;
    left: 10px;
    bottom: 10px;
}
.towerTag {
    font-size: 14px;
    color: #828282;
    text-shadow: 0px 0px 1px rgba(128, 128, 128, 0.7);
    position: absolute;
    right: 10px;
    bottom: 10px;
}
</style>